// extracted by mini-css-extract-plugin
export default {"CardTouch":"CardTouch_CardTouch__7J37l"};